/**
 * @generated SignedSource<<f5cd8f9b1a2e6b07aaad5709a3654fd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type fileAlreadyExistsChecker_Query$variables = {
  fileName?: string | null | undefined;
};
export type fileAlreadyExistsChecker_Query$data = {
  readonly Admin: {
    readonly FileAlreadyExist: {
      readonly Files: ReadonlyArray<{
        readonly fileAlreadyExist: ReadonlyArray<{
          readonly name: string;
        } | null | undefined>;
      }>;
    };
  };
};
export type fileAlreadyExistsChecker_Query = {
  response: fileAlreadyExistsChecker_Query$data;
  variables: fileAlreadyExistsChecker_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileName",
    "variableName": "fileName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fileAlreadyExistsChecker_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FileAlreadyExistAdminSchema",
            "kind": "LinkedField",
            "name": "FileAlreadyExist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "FileAlreadyExist",
                "kind": "LinkedField",
                "name": "Files",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "fileAlreadyExist",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fileAlreadyExistsChecker_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FileAlreadyExistAdminSchema",
            "kind": "LinkedField",
            "name": "FileAlreadyExist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "FileAlreadyExist",
                "kind": "LinkedField",
                "name": "Files",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "fileAlreadyExist",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63ff58b8c3b01057af8ce5b25e755856",
    "id": null,
    "metadata": {},
    "name": "fileAlreadyExistsChecker_Query",
    "operationKind": "query",
    "text": "query fileAlreadyExistsChecker_Query(\n  $fileName: String\n) {\n  Admin {\n    FileAlreadyExist {\n      Files(fileName: $fileName) {\n        fileAlreadyExist {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6738615f8f647847c9501e121ea72c84";

export default node;
